var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineData2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 8.75C2.48 8.75 1.25 7.52 1.25 6V4c0-1.52 1.23-2.75 2.75-2.75h3c1.52 0 2.75 1.23 2.75 2.75v2c0 1.52-1.23 2.75-2.75 2.75H4zM2.75 4v2c0 .69.56 1.25 1.25 1.25h3c.69 0 1.25-.56 1.25-1.25V4c0-.69-.56-1.25-1.25-1.25H4c-.69 0-1.25.56-1.25 1.25zM17.2 7.75c-1.08 0-1.95-.88-1.95-1.95V4.2c0-1.08.88-1.95 1.95-1.95h3.6c1.08 0 1.95.88 1.95 1.95v1.6c0 1.08-.87 1.95-1.95 1.95h-3.6zm-.45-3.55v1.6c0 .24.21.45.45.45h3.6c.24 0 .45-.21.45-.45V4.2c0-.24-.21-.45-.45-.45h-3.6c-.24 0-.45.21-.45.45zM17.2 15.25c-1.08 0-1.95-.88-1.95-1.95v-1.6c0-1.08.88-1.95 1.95-1.95h3.6c1.08 0 1.95.88 1.95 1.95v1.6c0 1.08-.87 1.95-1.95 1.95h-3.6zm-.45-3.55v1.6c0 .24.21.45.45.45h3.6c.24 0 .45-.21.45-.45v-1.6c0-.24-.21-.45-.45-.45h-3.6c-.24 0-.45.21-.45.45z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 5.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h7c.41 0 .75.34.75.75s-.34.75-.75.75H9z",
    fill: "#292D32",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 5v13c0 1.1.9 2 2 2H16",
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 20.75c-1.52 0-2.75-1.23-2.75-2.75V5c0-.41.34-.75.75-.75s.75.34.75.75v13c0 .69.56 1.25 1.25 1.25H16c.41 0 .75.34.75.75s-.34.75-.75.75h-1.5z",
    fill: "#292D32",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M12.5 12.5H16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 13.25c-.41 0-.75-.34-.75-.75s.34-.75.75-.75H16c.41 0 .75.34.75.75s-.34.75-.75.75h-3.5z",
    fill: "#292D32",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2 22.75c-1.08 0-1.95-.88-1.95-1.95v-1.6c0-1.08.88-1.95 1.95-1.95h3.6c1.08 0 1.95.88 1.95 1.95v1.6c0 1.08-.87 1.95-1.95 1.95h-3.6zm-.45-3.55v1.6c0 .24.21.45.45.45h3.6c.24 0 .45-.21.45-.45v-1.6c0-.24-.21-.45-.45-.45h-3.6c-.24 0-.45.21-.45.45z",
    fill: "#292D32"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineData2);
export default __webpack_public_path__ + "static/media/vuesax-outline-data-2.fda3830ceab588497aeeb5b4b333396d.svg";
export { ForwardRef as ReactComponent };